import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LibChevronIconModule } from '../icons/lib-chevron-icon/lib-chevron-icon.module';
import { LibPanelModule } from '../lib-panel/lib-panel.module';
import { LibSpinnerModule } from '../lib-spinner/lib-spinner.module';
import { LibAccordionRefreshComponent } from './lib-accordion-refresh.component';

@NgModule({
  imports: [CommonModule, LibPanelModule, LibChevronIconModule, LibSpinnerModule],
  declarations: [LibAccordionRefreshComponent],
  exports: [LibAccordionRefreshComponent],
})
export class LibAccordionRefreshModule {}
